<div class="content d-inline-flex">
  <i phx-icon phx-tooltip [phxContent]="notes?.length > 0 ? noteBody : noNote" [phxIcon]="DocumentInverted" [color]="notes?.length > 0 ? phxWebStyleTokens.colorContent : phxWebStyleTokens.colorContentFaded"></i>
</div>

<ng-template #noteBody>
  <div class="tooltip">
  <dismissal-note *ngIf="lastNote?.dismissalReasons?.length; else lastNoteBody"
    [note]="lastNote">
  </dismissal-note>

  <ng-template #lastNoteBody>
    <div class="description semi-bold ellipsis">{{lastNote?.body}}</div>
  </ng-template>
    <div class="fz-12 phx-web-color-content-on-inverted mb-5">
      <div>{{lastNote?.user?.name}}</div>
      <div>{{lastNote?.createdAt | moment: 'D/MM/YYYY hh:mm A z'}}</div>
    </div>
    <div *ngIf="hasMultipleNotes" class="more-notes justify-start">{{multiNotesText}}</div>
  </div>
</ng-template>

<ng-template #noNote>
  <span i18n>No note added</span>
</ng-template>
